<template>
    <div>
      <v-row class="pt-3 pl-3">
        <h2>
          <span class="blue-grey--text text--darken-1">Official Name: </span>
          {{ registration.officialName }}
        </h2>&nbsp;
      </v-row>
      <v-row>
        <v-col>
          <h3>
            <span class="blue-grey--text text--darken-1">Call Name: </span>
            {{ registration.callName }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Gender: </span>
            {{ registration.gender }}
          </h3>   
          <h3>
            <span class="blue-grey--text text--darken-1">Birth Date: </span>
            {{ $dateUtils.formatDate(registration.birthDate) }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Eyes: </span>
            Left: {{ registration.leftEyeColor }} • Right: {{ registration.rightEyeColor }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Colors: </span>
            Main: {{ registration.mainColor }} • Trim: {{ registration.trimColor }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Not for breeding: </span>
            {{ registration.notForBreeding ? 'Yes' : 'No' }}
          </h3>                                
          <h3>
            <span class="blue-grey--text text--darken-1"> Litter ID#: {{ registration.litterId }} </span>                 
          </h3>
        </v-col>
        <v-col>          
          <CoownersList :owners="registration.owners" :ownershipType="dogOwnershipType" :hideHeader="false" customHeader="Puppy/Dog owners"/>
        </v-col>
        <v-col>     
          <div v-if="!!registration && !!registration.kennels && registration.kennels.length > 0">                    
              <h3>
                <span class="blue-grey--text text--darken-1"> Kennel names used: </span>                 
              </h3>
              <ul v-for="kennel in registration.kennels" v-bind:key="kennel.kennelId">
                  <li><b>{{kennel.kennelName}} </b></li>
              </ul>
          </div>   
          <div v-else>                 
              <h3>
                <span class="blue-grey--text text--darken-1"> No Kennel names used </span>
              </h3>
          </div>  
        </v-col>
      </v-row>
      <v-row>            
            <v-col cols="12" sm="6"> 
                <h2 class="blue-grey--text text--darken-1">Dam:</h2>
                <v-row class="mt-5">
                    <v-col cols="1">
                        <v-img :src="defaultImage" class="profile-picture" min-width="40px" max-width="40px" contain />
                    </v-col>
                    <v-col cols="11">
                        <h3><b>{{registration.dam?.name}}</b></h3>
                        <span>{{registration.dam?.ascaId}} • {{registration.dam?.mainColor}} • {{registration.dam?.dnaStatus}}</span>
                    </v-col>
                </v-row>      
                <v-row>
                    <v-col cols="10">
                        <h4 class="blue-grey--text text--darken-1" v-if="registration.dam?.leaseInfo">Leesses
                            &nbsp;(Lease: {{$dateUtils.formatDate(registration.dam?.leaseInfo?.startDate)}} - {{$dateUtils.formatDate(registration.dam?.leaseInfo?.endDate)}})
                        </h4>
                        <CoownersList :owners="registration.dam?.owners" :ownershipType="dogOwnershipType" :hideHeader="registration.dam?.leaseInfo"/>
                    </v-col>
                    <v-spacer/>
                </v-row> 
            </v-col>
            <v-divider vertical light class="d-none d-sm-flex"></v-divider>
            <v-col cols="12" sm="6">
                <h2 class="blue-grey--text text--darken-1">Sire:</h2>
                <v-row class="mt-5">
                    <v-col cols="1">
                        <v-img :src="defaultImage" class="profile-picture" min-width="40px" max-width="40px" contain />
                    </v-col>
                    <v-col cols="11">
                        <h3><b>{{registration.sire?.name}}</b></h3>
                        <span>{{registration.sire?.ascaId}} • {{registration.sire?.mainColor}} • {{registration.sire?.dnaStatus}}</span>
                    </v-col>
                </v-row>      
                <v-row>
                    <v-col cols="10">
                        <h4 class="blue-grey--text text--darken-1" v-if="registration.sire?.leaseInfo">Leesses
                            &nbsp;(Lease: {{$dateUtils.formatDate(registration.sire?.leaseInfo?.startDate)}} - {{$dateUtils.formatDate(registration.sire?.leaseInfo?.endDate)}})
                        </h4>
                        <CoownersList :owners="registration.sire?.owners" :ownershipType="dogOwnershipType" :hideHeader="registration.sire?.leaseInfo"/>
                    </v-col>
                    <v-spacer/>
                </v-row>
            </v-col>
        </v-row>
    </div>
  </template>
  
<script lang="ts">
import Vue from "vue";
const defaultImage = require('@/assets/photouploadblue.png');
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

export default Vue.extend({
    name: "DogRegistrationIndividualRequest",
    components: { 
      CoownersList     
    },
    props: {
      registration: { type: Object },
    },
    data: function () {
      return {
          defaultImage,
      };
    },
    computed: {
      dogOwnershipType: function() {
        return OwnershipType.Dog;
      },
  }
  });
  </script>